import { Link as MuiLink, styled } from '@mui/material';
import { ComponentProps } from 'react';
import { Link as RouterLink } from 'react-router-dom';

export const Link = styled((props: ComponentProps<typeof MuiLink> & ComponentProps<typeof RouterLink>) => (
  <MuiLink component={RouterLink} {...props} to={props.to ?? props.href} />
))(({ color }) => ({ color: color ?? 'inherit' }));
